import { string, oneOfType, instanceOf } from "prop-types";

export const timestampLabelPropTypes = {
  dateTime: oneOfType([string, instanceOf(Date)]),
  label: string,
  format: string,
};
